module.exports = __webpack_public_path__ + "static/img/left.f42658e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/left.png
// module id = xDWF
// module chunks = 1